import styled from 'styled-components';

export const AddPaymentMethodButtonRoot = styled.button`
  padding: 0 ${({ theme }) => theme.spacers.L};
  border-radius: ${({ theme }) => theme.borderRadius.S};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 60px;
  flex-shrink: 0;
  font-family: 'Inter', sans-serif;
  ${({ theme }) => theme.typography.RegularParagraph};
  font-weight: 500;
  border: 2px solid ${({ theme }) => theme.colors.stroke.lighterGrey};
  background-color: ${({ theme }) => theme.colors.background.white};
  cursor: pointer;
  transition: background-color 200ms ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.superLightGrey};
  }
`;
